import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
  showRank?: boolean;
  rank?: number;
}

export default function ComicCard({ comic, size = 'medium', showRank = false, rank }: ComicCardProps) {
  const coverClasses = {
    small: 'w-24 h-32',
    medium: 'w-full aspect-[3/4]',
    large: 'w-full aspect-[3/4]',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg">
        {showRank && rank && (
          <div className="absolute top-2 left-2 z-10 w-7 h-7 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center text-sm font-bold shadow-sm">
            {rank}
          </div>
        )}
        <div className={coverClasses[size]}>
          <img
            src={comic.cover}
            alt={comic.title}
            title={`${comic.title} - 妖精漫画网免费漫画`}
            className="w-full h-full object-cover object-top rounded-lg transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2.5">
          {comic.status === '连载中' && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500/90 text-white dark:text-foreground-950 whitespace-nowrap">
              {comic.latestChapter}
            </span>
          )}
          {comic.status === '已完结' && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500/90 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              已完结
            </span>
          )}
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
          <span>{comic.author}</span>
          <span className="text-background-300">|</span>
          <span className="flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
            {comic.rating}
          </span>
        </div>
        {size !== 'small' && (
          <div className="flex flex-wrap gap-1 mt-1.5">
            {comic.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}